import HelpTip from './HelpTip.js'
import './HelpTip.scss'
export default HelpTip
